import {
	createQueryHook,
	createMutationHook,
} from '../../admin/queries/createQuery';
import { fieldQueryKeys } from './keys';

/**
 * Service query - Fully typed against FrontendEndpoints
 */
export const useServiceQuery = createQueryHook(
	'/gp-bookings/v1/services/:id',
	(params) => fieldQueryKeys.service(params!.id)
);

/**
 * Service resources query - Fully typed
 */
export const useServiceResourcesQuery = createQueryHook(
	'/gp-bookings/v1/services/:id/resources',
	(params) => ['service-resources', params!.id]
);

/**
 * Month availability query - Fully typed
 */
export const useMonthAvailabilityQuery = createQueryHook(
	'/gp-bookings/v1/availability/days',
	(params) =>
		fieldQueryKeys.monthAvailability(
			params!.serviceId,
			params!.year,
			params!.month,
			params!.resources || [],
			params!.resourceMode || 'any',
			params!.excludeBookingId || 0
		)
);

/**
 * Time slots query - Fully typed
 */
export const useTimeSlotsQuery = createQueryHook(
	'/gp-bookings/v1/availability/day',
	(params) =>
		fieldQueryKeys.timeSlots(
			params!.serviceId,
			params!.date,
			params!.resources || [],
			params!.duration || 0,
			params!.slotMode,
			params!.interval || 0,
			params!.resourceMode || 'any',
			params!.excludeBookingId || 0
		)
);

/**
 * Range capacity query - Fully typed
 */
export const useRangeCapacityQuery = createQueryHook(
	'/gp-bookings/v1/availability/range',
	(params) =>
		fieldQueryKeys.rangeCapacity(
			params!.serviceId,
			params!.start,
			params!.end,
			params!.resources || [],
			params!.resourceMode || 'any',
			params!.excludeBookingId || 0
		)
);

/**
 * First available month query - Fully typed
 */
export const useFirstAvailableQuery = createQueryHook(
	'/gp-bookings/v1/availability/first-available',
	(params) => [
		'first-available',
		params!.serviceId,
		params!.resources || [],
		params!.resourceMode || 'any',
	]
);

/**
 * Available slots query (for simple display mode) - Fully typed
 */
export const useAvailableSlotsQuery = createQueryHook(
	'/gp-bookings/v1/availability/slots',
	(params) =>
		fieldQueryKeys.availableSlots(
			params!.serviceId,
			params!.resources || [],
			params!.limit || 20,
			params!.slotMode || 'fixed',
			params!.interval || 0,
			params!.duration || 0,
			params!.resourceMode || 'any',
			params!.excludeBookingId || 0
		)
);

/**
 * Calculate price mutation - Fully typed
 */
export const useCalculatePriceMutation = createMutationHook(
	'POST',
	'/gp-bookings/v1/calculate-price'
);
